module.exports = __webpack_public_path__ + "img/globe.dd5152c7.svg";